// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseResourceProgress
 */
export interface ResponseResourceProgress {
  /**
   *
   * @type {number}
   * @memberof ResponseResourceProgress
   */
  candidates?: number;
  /**
   *
   * @type {number}
   * @memberof ResponseResourceProgress
   */
  completed?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseResourceProgress
   */
  group?: string;
  /**
   *
   * @type {number}
   * @memberof ResponseResourceProgress
   */
  inProgress?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseResourceProgress
   */
  kind?: string;
  /**
   * Skipped is the number of resources of this kind that carry the skip
   * annotation and are therefore not counted above.
   * @type {number}
   * @memberof ResponseResourceProgress
   */
  skipped?: number;
  /**
   *
   * @type {number}
   * @memberof ResponseResourceProgress
   */
  targeted?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseResourceProgress
   */
  version?: string;
}

/**
 * Check if a given object implements the ResponseResourceProgress interface.
 */
export function instanceOfResponseResourceProgress(
  value: object,
): value is ResponseResourceProgress {
  return true;
}

export function ResponseResourceProgressFromJSON(
  json: any,
): ResponseResourceProgress {
  return ResponseResourceProgressFromJSONTyped(json, false);
}

export function ResponseResourceProgressFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseResourceProgress {
  if (json == null) {
    return json;
  }
  return {
    candidates: json['candidates'] == null ? undefined : json['candidates'],
    completed: json['completed'] == null ? undefined : json['completed'],
    group: json['group'] == null ? undefined : json['group'],
    inProgress: json['inProgress'] == null ? undefined : json['inProgress'],
    kind: json['kind'] == null ? undefined : json['kind'],
    skipped: json['skipped'] == null ? undefined : json['skipped'],
    targeted: json['targeted'] == null ? undefined : json['targeted'],
    version: json['version'] == null ? undefined : json['version'],
  };
}

export function ResponseResourceProgressToJSON(
  json: any,
): ResponseResourceProgress {
  return ResponseResourceProgressToJSONTyped(json, false);
}

export function ResponseResourceProgressToJSONTyped(
  value?: ResponseResourceProgress | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    candidates: value['candidates'],
    completed: value['completed'],
    group: value['group'],
    inProgress: value['inProgress'],
    kind: value['kind'],
    skipped: value['skipped'],
    targeted: value['targeted'],
    version: value['version'],
  };
}
